import { Box, Paper, Typography, useTheme } from '@mui/material';
import type { NumberedInsightListData } from '../../types';
import TileMetaActions from '../TileMetaActions';

type Props = { data: NumberedInsightListData };

export default function NumberedInsightListRenderer({ data }: Props) {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        p: 2.5,
        width: '100%',
        position: 'relative',
      }}
    >
      <TileMetaActions query={data.meta?.query} registry={data.meta?.registry} />
      {data.items.map((item, index) => (
        <Box
          key={item.summary}
          sx={{
            display: 'flex',
            gap: 1.5,
            mb: index < data.items.length - 1 ? 2 : 0,
            pb: index < data.items.length - 1 ? 2 : 0,
            borderBottom:
              index < data.items.length - 1 ? `1px solid ${theme.palette.divider}` : 'none',
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: 'primary.main', minWidth: 28, lineHeight: 1.2 }}
          >
            {index + 1}
          </Typography>
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
              {item.summary}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.5 }}>
              {item.detail}
            </Typography>
          </Box>
        </Box>
      ))}
    </Paper>
  );
}
